import React from "react";
import BlankStateV2 from "@ui/BlankStateV2";
import { NoData } from "@ui/Illustration/react";
import t from "../../../i18n";
import { useDisplayFilterPreferences } from "./useDisplayFilterPreferences";

export function DisplayFiltersBlankState({ projectId }: { projectId: string }) {
  const { setDisplayFilterPreferences } = useDisplayFilterPreferences(projectId);

  const resetDisplayFilters = React.useCallback(() => {
    setDisplayFilterPreferences(undefined);
  }, [setDisplayFilterPreferences]);

  return (
    <BlankStateV2
      picto={<NoData />}
      title={t("project.display_filter.no_data.title")}
      subtitle={t("project.display_filter.no_data.description")}
      onClick={resetDisplayFilters}
      buttonLabel={t("project.display_filter.no_data.reset")}
    />
  );
}
